import { render, staticRenderFns } from "./ReportResident.vue?vue&type=template&id=5d390df3&"
import script from "./ReportResident.vue?vue&type=script&lang=js&"
export * from "./ReportResident.vue?vue&type=script&lang=js&"
import style0 from "./ReportResident.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports